import { Injectable } from '@angular/core';
import { HttpService } from 'services/http/http.service';
import { ShowIfHttpError } from '@certemy/common';
import { Observable } from 'rxjs';
import { Country, State } from 'interfaces/public-global.interface';

@Injectable({
  providedIn: 'root',
})
export class PublicGlobalService {
  constructor(private http: HttpService) {}

  @ShowIfHttpError('Cannot get countries.')
  getCountries(onlyDefaultCountries = false): Observable<Country[]> {
    const queryParams = onlyDefaultCountries ? '?defaultCountries=true' : '';
    return this.http.get(`/public/global/countries${queryParams}`);
  }

  @ShowIfHttpError('Cannot get states.')
  getStates(onlyDefaultStates = true): Observable<State[]> {
    const queryParams = onlyDefaultStates ? '' : '?defaultStates=false';
    return this.http.get(`/public/global/states${queryParams}`);
  }
}
